module.exports = __webpack_public_path__ + "img/IT0005223346897.1b6c495c.png";